<mat-dialog-content>
  <h2>{{'user-no-access-dialog.accessDeniedTitle' | translate}}</h2>
  <p>{{'user-no-access-dialog.accessDeniedContent' | translate}}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-dialog-close class="btn btn-link logout-button">{{'user-no-access-dialog.logout' | translate}}</button>
</mat-dialog-actions>

